<section
  class="atw-page create-company-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>
  <span class="dots dots-left"></span>
  <span class="dots dots-right"></span>

  <main class="atw-container">
    <section class="apply-section" id="createCompany">
      <div class="section-title create-company-title">
        <span>
          <b>{{ 'atw.createCompany.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.createCompany.title' | transloco }}</h2>
          <p>{{ 'atw.createCompany.subtitle' | transloco }}</p>
        </div>
      </div>

      <form
        class="apply-card smart-search-card company-form-card"
        [formGroup]="companyForm"
        novalidate
        (ngSubmit)="handleSubmit()"
      >
        <div class="smart-stepper company-stepper">
          <button
            type="button"
            class="step-pill"
            [class.active]="currentStep === 'company'"
            [class.done]="isStepDone('company')"
            (click)="goToStep('company')"
          >
            <strong>1</strong>
            <span>{{ 'atw.createCompany.steps.companyInformation' | transloco }}</span>
          </button>

          <div class="step-line"></div>

          <button
            type="button"
            class="step-pill"
            [class.active]="currentStep === 'contact'"
            [class.done]="isStepDone('contact')"
            (click)="goToStep('contact')"
          >
            <strong>2</strong>
            <span>{{ 'atw.createCompany.steps.contactInformation' | transloco }}</span>
          </button>

          <div class="step-line"></div>

          <button
            type="button"
            class="step-pill"
            [class.active]="currentStep === 'logo'"
            [class.done]="isStepDone('logo')"
            (click)="goToStep('logo')"
          >
            <strong>3</strong>
            <span>{{ 'atw.createCompany.steps.companyLogo' | transloco }}</span>
          </button>
        </div>

        <!-- Step 1 -->
        <ng-container *ngIf="currentStep === 'company'">
          <div class="detected-title-card company-step-note">
            <span>{{ 'atw.createCompany.sections.companyInformation' | transloco }}</span>
            <strong>{{ 'atw.createCompany.stepNotes.companyInformation' | transloco }}</strong>
          </div>

          <div class="form-grid">
            <div class="form-group">
              <label>
                {{ 'atw.createCompany.fields.name' | transloco }}
                *
              </label>

              <input
                type="text"
                formControlName="name"
                [placeholder]="'atw.createCompany.placeholders.name' | transloco"
              />

              <small
                class="error-message"
                *ngIf="f['name'].touched && f['name'].hasError('required')"
              >
                {{ 'atw.createCompany.validation.nameRequired' | transloco }}
              </small>
            </div>

            <div class="form-group">
              <label>{{ 'atw.createCompany.fields.nameAr' | transloco }}</label>

              <input
                type="text"
                formControlName="name_ar"
                [placeholder]="'atw.createCompany.placeholders.nameAr' | transloco"
              />
            </div>

            <div class="form-group">
              <label>{{ 'atw.createCompany.fields.specialty' | transloco }}</label>

              <input
                type="text"
                formControlName="specialty"
                [placeholder]="'atw.createCompany.placeholders.specialty' | transloco"
              />
            </div>

            <div class="form-group">
              <label>{{ 'atw.createCompany.fields.industry' | transloco }}</label>

              <input
                type="text"
                formControlName="industry"
                [placeholder]="'atw.createCompany.placeholders.industry' | transloco"
              />
            </div>

            <div class="form-group">
              <label>
                {{ 'atw.createCompany.fields.country' | transloco }}
                *
              </label>

              <select
                formControlName="country_id"
                (change)="onCountryChange($event)"
              >
                <option value="">
                  {{
                    isCountriesLoading
                      ? ('atw.createCompany.placeholders.loadingCountries' | transloco)
                      : ('atw.createCompany.placeholders.selectCountry' | transloco)
                  }}
                </option>

                <option
                  *ngFor="let country of countries; trackBy: trackByCountryId"
                  [value]="getCountryId(country)"
                >
                  {{ getCountryName(country) }}
                </option>
              </select>

              <small
                class="error-message"
                *ngIf="f['country_id'].touched && f['country_id'].hasError('required')"
              >
                {{ isAr ? 'اختار الدولة' : 'Select country' }}
              </small>
            </div>

            <div class="form-group">
              <label>
                {{ 'atw.createCompany.fields.city' | transloco }}
                *
              </label>

              <select
                formControlName="city_id"
                (change)="onCityChange($event)"
              >
                <option value="">
                  {{
                    isCitiesLoading
                      ? ('atw.createCompany.placeholders.loadingCities' | transloco)
                      : ('atw.createCompany.placeholders.selectCity' | transloco)
                  }}
                </option>

                <option
                  *ngFor="let city of cities; trackBy: trackByCityId"
                  [value]="getCityId(city)"
                >
                  {{ getCityName(city) }}
                </option>
              </select>

              <small
                class="error-message"
                *ngIf="f['city_id'].touched && f['city_id'].hasError('required')"
              >
                {{ isAr ? 'اختار المدينة' : 'Select city' }}
              </small>
            </div>

            <div class="form-group full-width">
              <label>{{ 'atw.createCompany.fields.address' | transloco }}</label>

              <textarea
                rows="3"
                formControlName="address"
                [placeholder]="'atw.createCompany.placeholders.address' | transloco"
              ></textarea>
            </div>
          </div>
        </ng-container>

        <!-- Step 2 -->
        <ng-container *ngIf="currentStep === 'contact'">
          <div class="detected-title-card company-step-note">
            <span>{{ 'atw.createCompany.sections.contactInformation' | transloco }}</span>
            <strong>{{ 'atw.createCompany.stepNotes.contactInformation' | transloco }}</strong>
          </div>

          <div class="form-grid">
            <div class="form-group">
              <label>
                {{ 'atw.createCompany.fields.tel' | transloco }}
                *
              </label>

              <input
                type="text"
                inputmode="tel"
                formControlName="tel"
                [placeholder]="'atw.createCompany.placeholders.tel' | transloco"
              />

              <small
                class="error-message"
                *ngIf="f['tel'].touched && f['tel'].hasError('required')"
              >
                {{ 'atw.createCompany.validation.telRequired' | transloco }}
              </small>
            </div>

            <div class="form-group">
              <label>{{ 'atw.createCompany.fields.fax' | transloco }}</label>

              <input
                type="text"
                formControlName="fax"
                [placeholder]="'atw.createCompany.placeholders.fax' | transloco"
              />
            </div>

            <div class="form-group">
              <label>{{ 'atw.createCompany.fields.email' | transloco }}</label>

              <input
                type="email"
                formControlName="contact_email"
                [placeholder]="'atw.createCompany.placeholders.email' | transloco"
              />

              <small
                class="error-message"
                *ngIf="f['contact_email'].touched && f['contact_email'].hasError('email')"
              >
                {{ 'atw.createCompany.validation.emailInvalid' | transloco }}
              </small>
            </div>

            <div class="form-group">
              <label>{{ 'atw.createCompany.fields.facebook' | transloco }}</label>

              <input
                type="text"
                formControlName="facebook"
                [placeholder]="'atw.createCompany.placeholders.facebook' | transloco"
              />
            </div>

            <div class="form-group">
              <label>{{ 'atw.createCompany.fields.linkedin' | transloco }}</label>

              <input
                type="text"
                formControlName="linkedin"
                [placeholder]="'atw.createCompany.placeholders.linkedin' | transloco"
              />
            </div>
          </div>
        </ng-container>

        <!-- Step 3 -->
        <ng-container *ngIf="currentStep === 'logo'">
          <div class="detected-title-card company-step-note">
            <span>{{ 'atw.createCompany.sections.companyLogo' | transloco }}</span>
            <strong>{{ 'atw.createCompany.stepNotes.companyLogo' | transloco }}</strong>
          </div>

          <div
            class="pdf-uploader logo-uploader"
            [class.drag-over]="logoDragOver"
            [class.has-file]="selectedLogo"
            (click)="!isLoading && companyLogoInput.click()"
            (dragover)="onLogoDragOver($event)"
            (dragleave)="onLogoDragLeave($event)"
            (drop)="onLogoDrop($event)"
          >
            <input
              #companyLogoInput
              type="file"
              accept="image/jpeg,image/jpg,image/png,image/webp"
              hidden
              [disabled]="isLoading"
              (change)="onLogoChange($event)"
            />

            <ng-container *ngIf="!selectedLogo">
              <div class="upload-icon">
                <span>🏢</span>
              </div>

              <h3>{{ 'atw.createCompany.upload.logoTitle' | transloco }}</h3>
              <p>{{ 'atw.createCompany.upload.logoHint' | transloco }}</p>

              <button
                type="button"
                class="browse-btn"
                [disabled]="isLoading"
                (click)="$event.stopPropagation(); companyLogoInput.click()"
              >
                {{ 'atw.createCompany.upload.chooseLogo' | transloco }}
                <span>↑</span>
              </button>
            </ng-container>

            <ng-container *ngIf="selectedLogo">
              <div class="file-preview logo-file-preview">
                <div class="logo-preview-thumb">
                  <img
                    *ngIf="logoPreview"
                    [src]="logoPreview"
                    [attr.alt]="'atw.createCompany.upload.logoPreviewAlt' | transloco"
                  />

                  <span *ngIf="!logoPreview">
                    {{ getLogoTypeLabel(selectedLogo) }}
                  </span>
                </div>

                <div class="file-info">
                  <strong>{{ selectedLogo.name }}</strong>
                  <span>{{ formatFileSize(selectedLogo.size) }}</span>
                </div>

                <button
                  type="button"
                  class="remove-file"
                  [disabled]="isLoading"
                  (click)="removeLogo($event, companyLogoInput)"
                >
                  ×
                </button>
              </div>
            </ng-container>
          </div>

          <div class="logo-help-card">
            <span>✓</span>
            <p>{{ 'atw.createCompany.upload.logoMaxHint' | transloco }}</p>
          </div>
        </ng-container>

        <div class="success-message" *ngIf="successMessage">
          {{ successMessage }}
        </div>

        <div class="error-message form-error" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <div class="company-form-actions">
          <button
            type="button"
            class="secondary-action company-back-btn"
            *ngIf="currentStep !== 'company'"
            [disabled]="isLoading"
            (click)="goBack()"
          >
            {{ 'atw.createCompany.actions.back' | transloco }}
          </button>

          <button
            type="button"
            class="submit-btn company-next-btn"
            *ngIf="currentStep !== 'logo'"
            [disabled]="isLoading"
            (click)="goNext()"
          >
            <span>{{ 'atw.createCompany.actions.next' | transloco }}</span>
          </button>

          <button
            type="submit"
            class="submit-btn company-submit-btn"
            *ngIf="currentStep === 'logo'"
            [disabled]="isLoading"
          >
            <span>
              {{
                isLoading
                  ? ('atw.createCompany.actions.saving' | transloco)
                  : ('atw.createCompany.actions.submit' | transloco)
              }}
            </span>
          </button>
        </div>
      </form>
    </section>
  </main>
</section>